import { useCallback } from 'react';
import type { FocusEvent } from 'react';

/**
 * Rola o campo focado para a vista, uma vez e sem animação.
 *
 * Decisão do dono (28/08/2026): o teclado PODE cobrir o botão OK. O único
 * requisito é o campo em digitação continuar visível.
 *
 * O que existia antes e foi removido: duas passadas de scroll com
 * `behavior: 'smooth'`, a segunda esperando o `visualViewport` estabilizar
 * (debounce de 150ms) porque o teclado do iOS leva 250–400ms para subir.
 * Somado ao encolhimento animado do container, dava ~850ms de movimento e a
 * tela parecia se ajeitar duas vezes — o campo ia ao centro, o teclado subia,
 * e ele ia ao centro de novo.
 *
 * `behavior: 'auto'` é deliberado: reposicionamento instantâneo, sem animação
 * que o olho acompanhe. O `requestAnimationFrame` garante que o scroll roda
 * depois de o browser aplicar o foco.
 */
export function useScrollIntoViewOnFocus<T extends HTMLElement = HTMLElement>() {
  return useCallback((e: FocusEvent<T>) => {
    const target = e.target;
    requestAnimationFrame(() => {
      target.scrollIntoView({ block: 'center', behavior: 'auto' });
    });
  }, []);
}
